import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import './PageStyle.css';
import ApiSender from './common/ApiLogic';

function PinPage() {

  const nav = useNavigate();
  const location = useLocation();
  const [language, setLanguage] = useState('EN');
  const [msisdn, setMsisdn] = useState(null);
  const [warning, setWarning] = useState(false);
  const [isGradient, setIsGradient] = useState(false);
  const [header, setHeader] = useState(false);
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const paramsObject = {};
  for (const [key, value] of params.entries()) {
    paramsObject[key] = value;
  }

  const [clientId, setClientId] = useState(null);
  const [status, setStatus] = useState(false);
  const [antiFraudUniqId, setAntiFraudUniqId] = useState(null);
  const [ti, setTi] = useState(null);
  const [ts, setTs] = useState(null);
  const [scriptInjected, setScriptInjected] = useState(false);
  const [clickId, setClickId] = useState(null);

  useEffect(() => {
    const apiSender = new ApiSender();
    async function fetchScript() {
      try {
        const result = await apiSender.loadExternalScript(msisdn, true);
        setClientId(result.clientId);
        setStatus(result.status);
        setAntiFraudUniqId(result.antiFraudUniqId);
        setTi(result.ti);
        setTs(result.ts);
        setScriptInjected(result.scriptInjected);
        setClickId(result.clickId);
      } catch (error) {
        console.error("Error loading external script:", error);
      }
    }
    fetchScript();
  }, []);

  useEffect(() => {
    if (status && !params.has("ClientID") && !params.has("RequestID")) {
      window.location.href = `https://kwhe.kid-security.io/he?ClientID=${clientId}&Channels=99942359,99942488,99943583`;
    }
    if (status && params.has("MSISDN")) {
      let m = params.get("MSISDN");
      if (m !== null && m !== undefined && (m.length === 8 || m.length === 11)) {
        if (m.length === 11 && m.startsWith('965')) {
          m = m.substring(3);
        }
        setMsisdn(m);
        document.getElementById('msisdn-val').disabled = true;
        setHeader(true);
      }
    }
  }, [status]);

  useEffect(() => {
    saveHistory();
  }, []);

  const saveHistory = async () => {
    const apiSender = new ApiSender();
    await apiSender.saveHistory(window.location.origin + location.pathname, paramsObject);
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang');
    if (!lang || (lang.toUpperCase() !== 'EN' && lang.toUpperCase() !== 'AR')) {
      return;
    }
    setLanguage(lang.toUpperCase());
    setIsGradient(lang.toUpperCase() === 'EN' ? true : false);
  }, []);

  const handleLanguage = (event) => {
    const selectedLang = event.target.textContent.trim();
    setLanguage(selectedLang === 'English' ? 'EN' : 'AR');
    setIsGradient(selectedLang === 'English' ? true : false);
  };

  const gradientStyle = {
    background: isGradient
      ? 'linear-gradient(to right, rgba(103, 193, 98, 0.4) 50%, rgba(103, 193, 98, 1) 50%)'
      : 'linear-gradient(to left, rgba(103, 193, 98, 0.4) 50%, rgba(103, 193, 98, 1) 50%)',
  };

  const handleMsisdnChange = (event) => {
    const newMsisdn = event.target.value;
    setMsisdn(newMsisdn);
    document.getElementById('country-code').style.color = 'black';
    setWarning(false);
  }

  const handleMsisdnFocus = () => {
    document.getElementById('country-code').style.color = 'black';
  }

  const handleMsisdnBlur = () => {
    if (msisdn === null || msisdn === undefined || msisdn.length === 0) {
      document.getElementById('country-code').style.color = '#999';
    }
  }

  const handleSendOtpClick = async () => {
    if (!isMsisdnValid()) {
      document.getElementById('warning-msg').textContent = language === 'EN' ? 'Incorrect Number Format' : 'رقم غير صحيح';
      setWarning(true);
      return;
    }

    document.getElementById('loading-spinner-send').style.display = 'inline-flex';
    document.getElementById('send-otp-btn').disabled = true;

    const apiSender = new ApiSender();
    const result = await apiSender.sendPin('send-pin', msisdn, language, antiFraudUniqId, clickId);
    if (result.success) {
      const data = {
        msisdn: msisdn, antiFraudUniqId: result.clickId, params: paramsObject, header: header, ti: ti, ts: ts, scriptInjected: scriptInjected
      };
      nav(`/verify?lang=${language}`, { state: data });
      return;
    }
    document.getElementById('loading-spinner-send').style.display = 'none';
    document.getElementById('send-otp-btn').disabled = false;
    setWarning(true);
    document.getElementById('warning-msg').textContent = result.message;
  }

  const isMsisdnValid = () => {
    if (msisdn !== null && msisdn !== undefined) {
      return isOoredoo(msisdn) || isStc(msisdn) || isZain(msisdn);
    }
    return false;
  }

  const isOoredoo = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return (msisdn.length === 11 && msisdn.startsWith('9656')) || (msisdn.length === 8 && msisdn.startsWith('6'));
    }
    return false;
  }

  const isStc = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return (msisdn.length === 11 && msisdn.startsWith('9655')) || (msisdn.length === 8 && msisdn.startsWith('5'));
    }
    return false;
  }

  const isZain = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return (msisdn.length === 11 && msisdn.startsWith('9659')) || (msisdn.length === 8 && msisdn.startsWith('9'));
    }
    return false;
  }

  return (
    <div className="Aa3">
      <div className='container'>
        <div className='header'>
          <div className='header-left'>
            <div className="language" style={gradientStyle} onClick={handleLanguage}>
              <div className='language-left'>
                <span>عربي</span>
              </div>
              <div className='language-middle'>
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeWidth="2" d="M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8"></path></svg>
              </div>
              <div className='language-right'>
                <span>English</span>
              </div>
            </div>
          </div>
          <div className='header-right'>
            <div className='logo'><img alt='Kid Security' src='%PUBLIC_URL%/../../kid-security-logo.png' /></div>
          </div>
        </div>
        <div className='form-content'>
          <div className='title'>
            <h4 id='headup-title'>{language === 'EN' ? 'Instant Download' : 'تنزيل سريع'}</h4>
          </div>
          <div className='form-content-top'>
            <div className='logo'><img alt='Kid Security' src='%PUBLIC_URL%/../../phone-icon.png' /></div>
          </div>
          <div className='form-content-middle'>
            <div className='title'>
              <h4 id='title'>{language === 'EN' ? 'Enter your mobile number' : 'ادخل رقم هاتفك المحمول'}</h4>
            </div>
            <div className='arrows' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1.25rem' }}>
              <svg fill="#000000" height={2} width={2} viewBox="0 0 330 330" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve"><path d="M15,180h263.787l-49.394,49.394c-5.858,5.857-5.858,15.355,0,21.213C232.322,253.535,236.161,255,240,255 s7.678-1.465,10.606-4.394l75-75c5.858-5.857,5.858-15.355,0-21.213l-75-75c-5.857-5.857-15.355-5.857-21.213,0 c-5.858,5.857-5.858,15.355,0,21.213L278.787,150H15c-8.284,0-15,6.716-15,15S6.716,180,15,180z" /></svg>
              <div id='msisdn-input' className={`input ${warning ? 'vibrate' : ''}`}>
                <span id='country-code' className='country-code'>+965</span>
                <input id='msisdn-val' type='tel' value={msisdn} placeholder='xxxxxxxx' autoComplete='off' minLength={8} maxLength={8} required onChange={handleMsisdnChange} onFocus={handleMsisdnFocus} onBlur={handleMsisdnBlur} />
                <div className='phone-logo'>
                  <img alt='' src='%PUBLIC_URL%/../../phone-logo.png' />
                </div>
              </div>
              <svg fill="#000000" height={2} width={2} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 400.004 400.004" xmlSpace="preserve"><g><path d="M382.688,182.686H59.116l77.209-77.214c6.764-6.76,6.764-17.726,0-24.485c-6.764-6.764-17.73-6.764-24.484,0L5.073,187.757 c-6.764,6.76-6.764,17.727,0,24.485l106.768,106.775c3.381,3.383,7.812,5.072,12.242,5.072c4.43,0,8.861-1.689,12.242-5.072 c6.764-6.76,6.764-17.726,0-24.484l-77.209-77.218h323.572c9.562,0,17.316-7.753,17.316-17.315 C400.004,190.438,392.251,182.686,382.688,182.686z" /></g></svg>
            </div>
            <div id='warning-msg-div' className={`warning-msg ${warning ? 'active' : ''}`}>
              <span id='warning-msg'>{language === 'EN' ? 'Incorrect Number Format' : 'رقم غير صحيح'}</span>
            </div>
            <div className='button'>
              <button id='send-otp-btn' style={{ display: 'block' }} onClick={handleSendOtpClick}>
                {language === 'EN' ? 'Continue' : 'تابع'}
                <div id="loading-spinner-send" className="spinner"></div>
              </button>
              <span>{language === 'EN' ? '' : ''}</span>
            </div>
          </div>
          <div className='form-content-bottom' style={{ direction: language === 'EN' ? "ltr" : "rtl" }}>
            {language === 'EN' ? (
              <span>
                Welcome to Kid Security, you will be billed 0.7 KWD per week for Ooredoo and enjoy a 1 day free trial for STC then 0.2 KWD per day and 1 day free trial for Zain then 0.7 KWD per week to unsubscribe send Stop 1 to 50712 for STC and Stop1 to 1769 for Ooredoo and Unsub KS to 97979 for Zain.
              </span>
            ) : (
              <span>
                مرحبًا بك في تطبيق Kid Security، سيتم خصم 0.7 دينار كويتي أسبوعيًا لمشتركي Ooredoo. ستحصل على فترة تجريبية مجانية ليوم واحد لمشتركي STC، وبعدها 0.2 دينار كويتي يوميًا. كما ستحصل على فترة تجريبية مجانية ليوم واحد لمشتركي Zain، وبعدها 0.7 دينار كويتي أسبوعيًا.لإلغاء الاشتراك، أرسل "Stop 1" إلى 50712 لمشتركي STC و"Stop1" إلى 1769 لمشتركي Ooredoo و"Unsub KS" إلى 97979 لمشتركي Zain.
              </span>
            )}
          </div>
          <div className='form-content-footer'>
            <Link to={`/terms?lang=${language}`}>{language === 'AR' ? (<a>أحكام وشروط</a>) : (<a>Terms and Condition</a>)}</Link>
            <svg fill="#000000" width="1em" height="1em" viewBox="-6.5 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M8.469-1.156h2.25v29.813h-2.25v-29.813z"></path></svg>
            {language === 'AR' ? (<a href='mailto:support@kid-security.io'>للتواصل انقر هنا</a>) : (<a href='mailto:support@kid-security.io'>Contact Us</a>)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PinPage;
